import { dissoc, prop } from "ramda";

export const getFeatureToggle = (state, feature) => {
  if (state && state.featureToggles) {
    return state.featureToggles[feature];
  }
  return false;
};

export const getFirstName = (state) => state.prospect.name.firstName;

export const getProspect = (state) => prop('prospect', state);

export const getReferenceNumber = (state) => state.applicationDecision.referenceNumber;

export const getDTMData = (state) => prop('dtm', state);

export const getCampaignDefaults = (state) => prop('campaignDefaults', state.envConfig);

export const getCampaignFromEnvConfig = (state) => prop('campaign', state.envConfig);

export const getCampaignFromState = (state) => prop('campaign', state);

export const getVeridConfig = (state) => prop('veridConfig', state.envConfig);

export const getVeridData = (state) => prop('veridData', state);

export const getAppState = (state) => dissoc('form', state);

export const getErrors = (state) => prop('errors', state);

export const getMiniAppState = (state) => ({
  errors: getErrors(state),
  loanAmount: state.loanAmount,
  email: state.email,
  dateOfBirth: state.dateOfBirth,
  grossAnnualIncome: state.grossAnnualIncome,
  additionalIncome: state.additionalIncome,
  prospect: state.prospect
});

export const getQuotes = (state) => prop('quotes', state);

export const getStep = (state) => prop('step', state);

export const getTimeout = (state) => prop('timeout', state);

export const isLoading = (state) => prop('isLoading', state);

export const getFocus = (state) => prop('focus', state);

export const getFrom = (state) => prop('from', state);

export const getLoanApplication = (state) => prop('loanApplication', state);

export const getApplicationId = (state) => state.loanApplication.applicationId;

export const getApplicationDecision = (state) => prop('applicationDecision', state);

export const getMarketCode = (state) => prop('marketCode', state);

export const getLandingCode = (state) => prop('landingCode', state);

export const getOfferPreFilledData = (state) => prop('creditCardApplicant', state);

export const getComboAppState = (state) => ({
  applicationId: state.loanApplication.applicationId,
  firstName: state.loanApplication.applicantName.firstName,
  middleInitial: state.loanApplication.applicantName.middleName,
  lastName: state.loanApplication.applicantName.lastName,
  suffix: state.loanApplication.applicantName.suffix,
  homeAddress: state.loanApplication.mailingAddress.lineOne,
  aptSuiteBldg: state.loanApplication.mailingAddress.lineTwo,
  cityTown: state.loanApplication.mailingAddress.city,
  state: state.loanApplication.mailingAddress.state,
  zip: state.loanApplication.mailingAddress.zip,
  grossAnnualIncome: state.loanApplication.grossAnnualIncome.amount,
  email: state.loanApplication.primaryEmail,
  phoneNumber: state.loanApplication.primaryPhone,
  loanAmount: state.loanApplication.loanAmount.amount,
  selectedQuote: {
    apr: state.loanApplication.apr,
    termInMonths: state.loanApplication.termInMonths,
    monthlyPayment: state.loanApplication.monthlyPayment.amount
  },
  marketCode: getMarketCode(state),
  loanPurpose: state.loanApplication.purposeOfLoan,
  consolidationAmount: state.loanApplication.consolidationAmount && state.loanApplication.consolidationAmount.amount
});

export const getLoanAmountBoundaries = (state) => ({
  minAmount: getCampaignFromState(state) ? getCampaignFromState(state).campaignCell.minAmount :
    getCampaignFromEnvConfig(state) ? getCampaignFromEnvConfig(state).minLoanAmount : undefined,
  maxAmount: getCampaignFromState(state) ? getCampaignFromState(state).campaignCell.maxAmount :
    getCampaignFromEnvConfig(state) ? getCampaignFromEnvConfig(state).maxLoanAmount : undefined
});

export const isNoInvitationDialogOpen = (state) => prop('isNoInvitationDialogOpen', state);
